export default () => ({
    showTools: false,
    toggleToolsContent() {
        this.showTools = !this.showTools;
    },
    hideToolsContent() {
        this.showTools = false;
    }
})